import { render } from "./Calendar.vue?vue&type=template&id=c51f23b4&scoped=true"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"

import "./Calendar.vue?vue&type=style&index=0&id=c51f23b4&lang=scss&scoped=true"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c51f23b4"]])

export default __exports__